import ViewBase from "../../../framework/core/mvvm/view_base";
import UserDataManager from "../../../manager/user_manager";


const {ccclass, property} = cc._decorator;


@ccclass
export default class ClubMemberPopView extends ViewBase {

    
    @property(cc.EditBox)
    setEditor : cc.EditBox = null;

    @property(cc.Label)
    currentLabel : cc.Label = null;

    @property(cc.Sprite)
    avatarIcon : cc.Sprite = null;

    @property(cc.Label)
    avatarName : cc.Label = null;

    @property(cc.Label)
    id : cc.Label = null;

    onLoad(){

        this.setEditor.node.on('text-changed', this.onSetEditor, this);
    }

    private onSetEditor(){

        if(!this.setEditor.string.match("^[0-9-]*$")){
            this.setEditor.string = this.setEditor.string.substring(0, this.setEditor.string.length - 1);
            this.setEditor.blur();
        }
    }


    public updateInfo(data : any){

        this.avatarName.string = data.nickname;

        UserDataManager.getAvatarSprite(data.headImg,(spriteFrame)=>{
            this.avatarIcon.spriteFrame = spriteFrame;
        });

        this.id.string = data.gameUserId;

        this.currentLabel.string = data.goldBalance;
        
    }
 


}
